// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'

import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import './assets/font/iconfont.css'
import './assets/css/indexforsearch.css'
import './assets/css/index.css'
// import './assets/css/element-ui-index.css'
import $ from 'jquery'
// import Papa from 'papaparse'
import App from './App.vue'
import store from './store';
Vue.use(ElementUI)
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
    render: h => h(App)
})

Vue.filter('getTypeName',function(val){
  switch (val){
        case 1:
          return "500强";
          break;
        case 2:
          return "100强";
          break;
        case 3:
          return "品牌价值";
          break;
      }
});
// 此处需要use后，this.$http.get或者this.$http.post才可以
Vue.use(VueRouter)
Vue.use(VueResource)



// WEBPACK FOOTER //
// ./src/main.js